// 所有自定义指令
import 'animate.css'
import {isString, isObject} from 'lodash'
export default defineNuxtPlugin(nuxtApp => {
    // name 动画名称，默认fadeIn
    // once 仅展示一次动画
    // {name: 'fadeIn', once: true}
    // 可使用修饰符作为动画效果如 .fadeIn，当前仅支持一种动画效果
    // 特殊修饰符，如 .infinite，保留后续开发
    // ---------- 后续动画效果可用使用 @vueuse/motion 替代，当前npm版本为2.0.0-beta.12，在.25发布到npm之前无法直接使用
    nuxtApp.vueApp.directive('animate', {
        mounted (el, binding) {
            var options = {
                name: 'fadeIn',
                once: true,
            }
            if(isString(binding.value)) options.name = binding.value
            if(isObject(binding.value)) Object.assign(options, binding.value)
            const modifiers = ['infinite']
            for(var key in binding.modifiers) {
                if(modifiers.includes(key)) return
                options.name = key
            }
            const visible = useElementVisibility(el)
            const stop = watch(() =>visible, val => {
                if(!val.value) return
                if(el.classList.contains(options.name)) return

                animateCSS(el, options.name)
                if(options.once) stop()
            }, {deep: true})
        },
    })

    // 图片懒加载
    // 将当前src字段置空,替换到data-src中,直到图片显示在界面再加载
    nuxtApp.vueApp.directive('lazy', {
        beforeMount(el, binding, vnode, prevVnode){
            el.dataset.src = el.src
            el.src = ''
        },
        mounted(el){
            const visible = useElementVisibility(el)
            const stop = watch(() => visible, val => {
                if(!val.value) return
                el.src = el.dataset.src
                stop()
            },{deep: true})
        }
    })
})
  